export const GET_NEW_LOCATION_LIST = '[LOGOUT] GET_NEW_LOCATION_LIST';
export const FORCE_SIGN_OUT_SUCCESS = '[LOGOUT] FORCE_SIGN_OUT_SUCCESS';

export default {
    FORCE_SIGN_OUT_SUCCESS,
    GET_NEW_LOCATION_LIST,
}


// WEBPACK FOOTER //
// ./src/view/constant/SignoutConstant.js